import { Controller } from "@hotwired/stimulus"

export default class VisibilityController extends Controller {
  static targets = ['item', 'empty', 'container']

  connect() {
    this.toggleEmptyMessage()
    this.observer = new MutationObserver(() => { this.toggleEmptyMessage() })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggleEmptyMessage() {
    if (!this.hasEmptyTarget) return

    const hasItems = this.itemTargets.length > 0

    this.emptyTarget.classList.toggle('d-none', hasItems)

    if (this.hasContainerTarget) {
      this.containerTarget.classList.toggle('d-none', !hasItems)
    }
  }
}
